import React from 'react';
import ReactDOM from 'react-dom/client';
import { SuperTokensWrapper } from 'supertokens-auth-react';
import { initSuperTokens } from './lib/supertokens';
import App from './App';
import './index.css';
import './utils/logger';

// Sentry error tracking
import * as Sentry from '@sentry/react';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  });
}

// Initialize SuperTokens before rendering
initSuperTokens();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SuperTokensWrapper>
      <App />
    </SuperTokensWrapper>
  </React.StrictMode>
);
